export default __webpack_public_path__ + "static/media/raumvideo.0bff90fb.mp4";